import { gql } from "@apollo/client"

const query = gql`
    query getCats {
        shops(onlyActive: true) {
            label: name
            value: id
            lang
        }
        baseData {
            categories {
                ...priceAlertsSelectFields
                type
                children {
                    ...priceAlertsSelectFields
                    type
                    children {
                        ...priceAlertsSelectFields
                        type
                        children {
                            ...priceAlertsSelectFields
                            type
                        }
                    }
                }
            }
        }
    }
    fragment priceAlertsSelectFields on Category {
        name
        value: name
        label: name
    }
`

const QUERY_PRODUCER = `query getProducer($department: String) {
  getProducerByQuery(
    department: $department
  ) {
    producerList {
        label: name
        value: id
    }
  }
}
`

const query_loadalerts = `mutation getLoadAlerts($userId: Int!) {
        loadAlerts(userId: $userId){
            id
            customerId
            name
            userName
            rule {
                shopIds
                productIds
                producerIds
                department
                productGroup
                productCat
                ruleCheck
                ruleValue
                rulePercent
                priceDiffMarge
                priceDiffToCustomerPriceInPercent
                minCustomerPriceForProductValidation
                priceDifferenceType
                exportType
                lowerPriceLimit
                referencePriceField
                stockCheckType
            }
            allowProductGroupingByProductNr
            checkType
            channel
            mails
            userId
            createDate
            active
        }
    }
`

const query_createalert = `mutation getCreateAlert($alert : AlertInput) {
        createAlert(alert : $alert) {
            customerId
            name
            rule {
                shopIds
                productIds
                producerIds
                department
                productGroup
                productCat
                ruleCheck
                ruleValue
                rulePercent
                priceDiffMarge
                priceDiffToCustomerPriceInPercent
                minCustomerPriceForProductValidation
                priceDifferenceType
                exportType
                lowerPriceLimit
                referencePriceField
                stockCheckType
            }
            allowProductGroupingByProductNr
            channel
            mails
            userId
            active
        }
    }
`

const query_deletealert = `mutation getDeleteAlert($alertId : Int!) {
        deleteAlert(alertId : $alertId)
    }
`

export { query, QUERY_PRODUCER, query_loadalerts, query_createalert, query_deletealert }
